import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import './overview/overview.css';

import Login from './auth/Login';
import Register from './auth/Register';
import DealerRegister from './auth/DealerRegister';
import DealerLogin from './auth/DealerLogin';
import DealerSubscription from './dealer/DealerSubscription';
import DealerInvoices from './dealer/DealerInvoices';
import ForgotPassword from './auth/ForgotPassword';
import ResetPassword from './auth/ResetPassword';
import VerifyEmail from './auth/VerifyEmail';
import CheckEmail from './auth/CheckEmail';
import Home from './home';
import UserAdsListing from './AddUserListing/UserAdsListing';
import AddUserListingSimple from './AddUserListing/AddUserListingSimple';
import BulkUploadPage from './bulk-upload/BulkUploadPage';
import ProtectedRoute from './components/ProtectedRoute';
import AdminDashboard from './admin/AdminDashboard';
import ListingDetails from './listing/ListingDetails';
import DealerShop from './dealer/DealerShop';

import Meinmobile from './meinmobile';
import Overview from './overview/Overview';
import Message from './overview/message';

import Ads from './overview/ads';
import Myvehicles from './overview/myvehicles';
import Settings from './overview/settings';
import Credits from './overview/Credits';
import Mysearch from './mysearch/mysearch';
import NotFound from './notfound';
import Profile from './profile/Profile';
import Favorites from './favorites/Favorites';
import SellerDetail from './sellerdetail/sellerdetail';
import About from './about-us';
import PrivacyPolicy from './privacypolicy';
import Termsandcondition from './termsandconditions';
import ContactUs from './contactus';
import Support from './support';
import AppRedirect from './AppRedirect';
import DownloadPage from './download/DownloadPage';
import ShortLinkRedirect from './download/ShortLinkRedirect';
import { AuthProvider } from './context/AuthContext';
import AppSmartBanner from './components/AppSmartBanner/AppSmartBanner';
function App() {
  return (
    <AuthProvider>
    <Router>
      <ScrollToTop />
      <AppSmartBanner />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
      />

      <Routes>
        {/* ===== AUTH ROUTES ===== */}
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/dealer-register" element={<DealerRegister />} />
        <Route path="/dealer-login" element={<DealerLogin />} />
        <Route path="/check-email" element={<CheckEmail />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/verify-email" element={<VerifyEmail />} />
        <Route path="/user-ads" element={<UserAdsListing />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/listing/:id" element={<ListingDetails />} />
        <Route path="/listing/:id/:slug" element={<ListingDetails />} />
        <Route path="/dealer/:dealerId" element={<DealerShop />} />
        <Route path="/mysearch" element={<Mysearch />} />
        <Route path="/app" element={<AppRedirect />} />
        <Route path="/download" element={<DownloadPage />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/seller-detail/:id" element={<SellerDetail />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<Termsandcondition />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/support" element={<Support />} />

        {/* ===== INFLUENCER SHORT LINKS (autoplace.al/:slug) ===== */}
        {/* Single-segment dynamic route: React Router ranks it below every
            static route above and above the "*" catch-all. */}
        <Route path="/:slug" element={<ShortLinkRedirect />} />

        {/* ===== DASHBOARD ROUTES ===== */}
        <Route path="/dashboard" element={<Meinmobile />}>
          <Route index element={<Overview />} /> {/* Default tab */}
          <Route path="overview" element={<Overview />} />
          <Route path="messages" element={<Message />} />

          <Route path="ads" element={<Ads />} />
          <Route path="myvehicles" element={<Myvehicles />} />
          <Route path="settings" element={<Settings />} />
          <Route path="credits" element={<Credits />} />
          <Route path="profile" element={<Profile />} />
          <Route path="favorites" element={<Favorites />} />
          <Route path="add-user-listing" element={<ProtectedRoute><AddUserListingSimple /></ProtectedRoute>} />
          <Route path="bulk-upload" element={<ProtectedRoute><BulkUploadPage /></ProtectedRoute>} />
          <Route path="subscription" element={<DealerSubscription />} />
          <Route path="invoices" element={<DealerInvoices />} />
        </Route>
      </Routes>
    </Router>
    </AuthProvider>
  );
}

export default App;
